var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.cssVars),attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view',{attrs:{"allConfig":_vm.allConfig}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }